import { UrlObject } from "url";

import { ButtonThemes } from "@/components/elements/Button";
import { LINKS } from "@/constants/links";

import { CartItem } from "./api/cart";
import { Dispenser } from "./api/dispensers";
import { TServerError, UserName } from "./api/shared";

export enum I18nextLocale {
  NO_NO = "no-NO",
  EN_NO = "en-NO",
}

export enum I18nextLanguage {
  NO = "no",
  EN = "en",
}

export enum I18nCountry {
  NO = "NO",
}

export type NewsletterData = {
  email: string;
};

export type ProductInfoSection = {
  title: string;
  copy: string | string[];
  isMultiLine?: boolean;
  startOpen?: boolean;
};

export type RequiredDispenser = {
  productTitle: string;
  productId: number;
  dispenser: Dispenser;
};

export type DispenserOption = CartItem & {
  productTitle: string;
  inventory: number;
};

export type AccountStats = {
  totalRefills: number;
  plasticSaved: {
    value: number;
    unit: string;
  };
  co2Saved: {
    value: number;
    unit: string;
  };
};

export type LinkType = "internal" | "external" | "email";

export type PageLink = keyof typeof LINKS;

export type FormProps = {
  legend?: string;
  hideLegend?: boolean;
  formDescription?: string | React.ReactElement;
  primaryButtonText?: string;
  primaryButtonTheme?: ButtonThemes;
  secondaryButtonEnhancerStart?: React.ReactNode;
  secondaryButtonText?: string;
  secondaryButtonAction?: () => void;
  footerContent?: React.ReactNode;
  children?: React.ReactNode;
  disabled?: boolean;
  isLoading?: boolean;
  serverError?: TServerError;
  onSubmit?: (e?: React.SyntheticEvent) => void;
  className?: string;
};

export type Url = UrlObject | string;

export enum AuthStatus {
  INITIAL_LOADING = "initial-loading",
  LOGGED_IN = "logged-in",
  LOGGED_OUT = "logged-out",
}

export type UserFormFields = Partial<UserName> & {
  email?: string;
  mobile?: string;
  locale?: I18nextLocale;
};

export type MDX = {
  default: unknown;
  meta: {
    title: string;
    heroSrc: string;
    description: string;
  };
};
